"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "isPlainObject", {
  enumerable: true,
  get: function get() {
    return _isPlainObject2.default;
  }
});
exports.noop = exports.returnSelf = exports.isFunction = exports.isArray = void 0;

var _isPlainObject2 = _interopRequireDefault(require("is-plain-object"));

var isArray = Array.isArray.bind(Array);
exports.isArray = isArray;

var isFunction = function isFunction(o) {
  return typeof o === 'function';
};

exports.isFunction = isFunction;

var returnSelf = function returnSelf(m) {
  return m;
};

exports.returnSelf = returnSelf;

var noop = function noop() {};

exports.noop = noop;